import styled from "styled-components";
import { GoPrimitiveDot } from "react-icons/go";
import { Container } from "../../../components/navbar/Nav.styles";
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";

const PayDay = () => {
  return (
    <ContainerProd>
      <Wrapper>
        <div>
          <div className="web__content">
            <h1>
              Get ahead with <span className="beta__life">Payday Credit</span>
            </h1>
            <p>
              This is a credit facility available to people who ahead of their
              payday need to attend to unforeseen contingencies. sometimes
              emergencies arise before payday and with our payday credit you
              can’t be low on cash.
            </p>
          </div>
          <img
            className="first__image"
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636145/invest-trust/Rectangle_49_4_tbztxl.png"
            alt="betalife"
          />
        </div>
        <BenefitComp>
          <div className="mobile__content">
            <h1>
              Get ahead with <span className="beta__life">Payday Credit</span>
            </h1>
            <p>
              This is a credit facility available to people who ahead of their
              payday need to attend to unforeseen contingencies. sometimes
              emergencies arise before payday and with our payday credit you
              can’t be low on cash.
            </p>
          </div>
          <div>
            <img
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651643636/invest-trust/young-attractive-black-businessman-buys-new-car-he-holds-keys-his-hand-dreams-come-true_1_t5f2i7.png"
              alt="betalife"
            />
          </div>
          <h2>Benefits</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point"/>
            <span>Instant loan without collateral</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point"/>
            <span>Flexible Payback period of one month</span>
          </BenefitItem>
          <br />
          <h2>Features</h2>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point"/>
            <span>Access to loan for both salary and business owners.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point"/>
            <span>Interest rate of 4%.</span>
          </BenefitItem>
          <div className="start__saving">
            <Button to="/pay">Start Saving</Button>
          </div>
        </BenefitComp>
      </Wrapper>
    </ContainerProd>
  );
};

export default PayDay;

export const ContainerProd = styled(Container)`
  transform: translateY(-8rem);
  background-color: #dbdbf9;
`;

export const Wrapper = styled.div`
  .web__view {
    display: none;
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.5rem;
  margin-bottom: 2rem;

  img {
    max-width: 100%;
  }

  div:nth-of-type(1) {
    // border: 3px solid teal;
  }

  div:nth-of-type(1) h1 {
    margin-top: 0rem;
    font-family: "Futura";
    font-size: 3rem;
    font-weight: 200;
    margin-bottom: 1rem;
  }
  div:nth-of-type(1) p {
    font-size: 20px;
    padding-right: 6.5rem;
    // border: 3px solid red;
  }

  .beta__life {
    color: ${({ theme }) => theme.colors.secondary};
  }

  .start__saving {
    margin-top: 4rem;
  }
  .start__saving a {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
  .first__image {
    margin-top: 2rem;
  }
  .bullet__point {
    font-size: 32px;
    color: #1b20e5;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 0rem;
    .start__saving {
      display: flex;
      justify-content: center;
    }
    .web__content {
      display: none;
    }
    .web__view {
      display: inline-block;
    }
    div:nth-of-type(1) h1 {
      font-size: 3rem;
      text-align: center;
    }
    .beta__life {
      display: block;
    }
    div:nth-of-type(1) p {
      font-size: 20px;
      padding-right: 0rem;
      text-align: center;
    }
  }
  @media screen and (max-width: 579px) {
    grid-template-columns: 1fr;
    .first__image {
      // border: 10px solid red;
      transform: translateY(-40rem);
      margin-bottom: -10rem;
    }
    .web__features {
      transform: translateY(-10rem);
      margin-bottom: -8rem;
      // border: 2px solid red;
    }
    div:nth-of-type(1) h1 {
      font-size: 2rem;
      text-align: center;
      line-height: 40px;
    }
    .bullet__point {
      margin-top: 0.4rem;
      font-size: 16px;
      color: #1b20e5;
    }
  }
`;

export const BenefitComp = styled.div`
  margin-bottom: 40rem;
  div: nth-of-type(2);
  .mobile__content {
    display: none;
  }
  .mobile__view {
    display: inline-block;
  }
  div: nth-of-type(2);
  @media screen and (max-width: 991px) {
    grid-row-start: 1;
    grid-row-end: 3;
    .mobile__content {
      display: block;
    }
    .mobile__view {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  // width: 577px;

  .product__dot {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondary};
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  span {
    font-size: 20px;
  }
  @media screen and (max-width: 991px) {
  }
  @media screen and (max-width: 579px) {
    align-items: flex-start;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  span {
    font-size: 20px;
    padding-right: 2rem;
  }
`;
